import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import OfficialIdUploader from '../components/official-id-uploader';
import {uploadOfficialId} from '../actions/official-id';

const mapStateToProps = ({educator: {officialIdPath}, officialIdUploading}) => ({
  image: officialIdPath,
  uploading: officialIdUploading,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      uploadOfficialId,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(OfficialIdUploader);
